import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {isEmpty} from 'lodash';
import * as actions from 'redux/actions/additionalHealthActions';
import {AppState} from 'redux/reducers';
import {AdditionalHealthState} from 'redux/reducers/additionalHealthReducer';
import {AdditionalHealthPaperworkStatus, AddHealth, UserBlob} from 'lib/entities';
import {isEmcEligible} from './utils/application';
import {UserState} from '../redux/reducers/usersReducer';
type UseAdditionalHealthState = AdditionalHealthState & {
    isConfirmed: boolean;
    isIncomplete: boolean;
};

export function isConfirmable(completedPaperwork: any, userState: UserState | UserBlob) {
    return isEmcEligible(userState, true)
        ? !!completedPaperwork?.weightChanged
        : completedPaperwork?.weightChanged &&
              completedPaperwork?.fatherStillLiving &&
              (completedPaperwork?.fatherAge ||
                  (completedPaperwork?.fatherPassedAtAge && completedPaperwork?.fatherCauseOfPassing) ||
                  completedPaperwork?.fatherAdditionalDetails) &&
              completedPaperwork?.motherStillLiving &&
              (completedPaperwork?.motherAge ||
                  (completedPaperwork?.motherPassedAtAge && completedPaperwork?.motherCauseOfPassing) ||
                  completedPaperwork?.motherAdditionalDetails) &&
              ((completedPaperwork?.showPCP === 'No' &&
                  !completedPaperwork.lastDoctorVisitIsRegularDoctor &&
                  !isEmpty(completedPaperwork.lastDoctorVisitCity) &&
                  !isEmpty(completedPaperwork.lastDoctorVisitLastVisited) &&
                  (completedPaperwork.lastDoctorVisitLastVisited as string).length === 7 &&
                  !isEmpty(completedPaperwork.lastDoctorVisitProviderName) &&
                  !isEmpty(completedPaperwork.lastDoctorVisitState) &&
                  !isEmpty(completedPaperwork.lastDoctorVisitStreet) &&
                  !isEmpty(completedPaperwork.lastDoctorVisitZip)) ||
                  completedPaperwork.lastDoctorVisitIsRegularDoctor ||
                  (completedPaperwork?.pcpName && completedPaperwork?.pcpStreet));
}

export function useAdditionalHealth() {
    const dispatch = useDispatch();
    const userState: UserState = useSelector((state: AppState): UserState => state.users[0]);

    const additionalHealthState = useSelector((state: AppState): UseAdditionalHealthState => {
        return {
            ...state.additionalHealth,
            isConfirmed: isEmcEligible(userState)
                ? typeof state.additionalHealth?.paperwork?.completedPaperwork?.existingCoverage === 'boolean' &&
                  typeof state.additionalHealth?.paperwork?.completedPaperwork?.adh_pcpyesno === 'boolean'
                : isConfirmable(state.additionalHealth?.paperwork?.completedPaperwork, userState) &&
                  state.additionalHealth.paperwork?.status === AdditionalHealthPaperworkStatus.CONFIRMED,
            isIncomplete:
                !isConfirmable(state.additionalHealth?.paperwork?.completedPaperwork, userState) ||
                state.additionalHealth.paperwork?.status === AdditionalHealthPaperworkStatus.INCOMPLETE,
        };
    });

    const save = useCallback(
        (addHealth: AddHealth, {shouldEndEditing = false} = {}) => {
            dispatch(actions.saveAddHealth(addHealth, {shouldEndEditing}));
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    const start = useCallback(() => {
        dispatch(actions.startAdditionalHealth());
    }, []);

    return {
        save,
        // confirm,
        start,
        ...additionalHealthState,
    };
}
